import {createSelector} from 'reselect';
import getBillingAddressDetails from '../BillingAddressSelectors/getBillingAddressDetails';

export default createSelector(
  [getBillingAddressDetails],
  billingAddressDetails => billingAddressDetails?.payerName || '',
);
